<template>
    <v-container fluid fill-height px-0 class="main-container container-fixed d-block">
        <div class="content-block">
            <v-layout class="remote-control" column>
                <v-flex class="chart-header mx-6">
                    <div class="arrow-btn d-inline-flex" @click="back">
                        <div v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')" class="d-inline-flex rotate-90 common-text" />
                    </div>
                    <div v-if="device" class="title-text d-inline-flex">
                        {{ device.name }}
                    </div>
                    <div class="d-inline-flex"></div>
                </v-flex>
                <v-flex d-flex justify-center class="location-header-row" v-if="device">
                    <div v-if="device.location" class="main-text d-inline-flex">({{device.location}})</div>
                </v-flex>
                <div class="main-text text-center mb-3" v-if="device && device.state">
                    <p v-if="device.state.temperature" class="d-inline-flex mb-2">Текущая температура: {{ (device.state.temperature).toFixed(1) }}°C;</p>
                    <p v-if="device.state.humidity" class="d-inline-flex">Текущая влажность: {{ (device.state.humidity).toFixed(1) }}%</p>
                </div>
                <div class="layout column" v-if="actions.length > 0">
                    <v-flex xs12 d-inline-flex justify-center align-center line-buttons>
                        <v-btn class="btn-dark mr-3" :class="{'btn-dark-active': week}" @click="week = true">
                            Неделя
                        </v-btn>
                        <v-btn class="btn-dark ml-3" :class="{'btn-dark-active': !week}" @click="week = false">
                            День
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 d-inline-flex justify-center align-center line-buttons v-if="!week">
                        <div @click="increaseDay" class="date-arrow left" :class="{'date-arrow__disabled': day == daysUniq.length - 1}">
                            <div v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')" class="d-inline-flex common-text" />
                        </div>
                        <div class="main-text">{{daysUniq[day] | formatDate }}</div>
                        <div @click="reduceDay" class="date-arrow right common-text" :class="{'date-arrow__disabled': day == 0}">
                            <div v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')" class="d-inline-flex" />
                        </div>
                    </v-flex>
                    <div class="common-text text-center px-2">
                        <div class="mt-2" v-if="device && device.device_type == 7">
                            Изменение температуры, °C
                        </div>
                        <div class="wrapper mb-5" v-if="device && device.device_type == 7">
                            <VueApexCharts width="100%" type="area" :options="chartTemperaturesOptions" :series="temperatures"></VueApexCharts>
                        </div>
                        <div class="mt-5" v-if="device && device.device_type == 18">
                            Изменение влажности, %
                        </div>
                        <div class="wrapper mb-3" v-if="device && device.device_type == 18">
                            <VueApexCharts width="100%" type="area" :options="chartHumiditiesOptions" :series="humidities"></VueApexCharts>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-center history-list__error" v-else>
                    <v-flex class="d-block text-center">
                        <div>
                            <div v-html="require('!html-loader!@/assets/images/error.svg')" class="d-inline-flex mb-8" />
                            <div class="common-text text-center">
                                Нет истории
                            </div>
                        </div>
                    </v-flex>
                </div>
            </v-layout>
        </div>
        <ModalWaiting v-model="openModalWaiting"></ModalWaiting>
    </v-container>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import ModalWaiting from "@/components/modals/ModalWaiting";
import {eventBus} from "@/main";

export default {
    name: "ChartPage",
    components: {ModalWaiting, VueApexCharts},
    data() {
        return {
            deviceUID: null,
            deviceType: null,
            actions: [],
            week: false,
            day: null,
            daysUniq: [],
            device: null,
            openModalWaiting: false,
            chartTemperaturesOptions: {
                chart: {
                    events: {
                        click: function(event, chartContext, config) {
                            let tooltip = chartContext.el.querySelector('.apexcharts-tooltip');
                            let pointsArray = config.globals.pointsArray;
                            let seriesIndex = config.seriesIndex;
                            let dataPointIndex = config.dataPointIndex === -1 ? 0 : config.dataPointIndex;

                            if (seriesIndex !== -1) {
                                let position = pointsArray[seriesIndex][dataPointIndex];

                                tooltip.style.top = position[1] + 'px';
                                tooltip.style.left = position[0] + 'px';
                            }
                        },
                        mouseMove: function(event, chartContext, config) {
                            let tooltip = chartContext.el.querySelector('.apexcharts-tooltip');
                            let pointsArray = config.globals.pointsArray;
                            let seriesIndex = config.seriesIndex;
                            let dataPointIndex = config.dataPointIndex === -1 ? 0 : config.dataPointIndex;

                            if (seriesIndex !== -1) {
                                let position = pointsArray[seriesIndex][dataPointIndex];

                                tooltip.style.top = position[1] + 'px';
                                tooltip.style.left = position[0] + 'px';
                            }
                        },
                    },
                    height: 350,
                    toolbar: {
                        show: false,
                    },
                    type: "area",
                    zoom: {
                        enabled: false,
                    },
                },
                colors: ["#FFA64D"],
                dataLabels: {
                    enabled: false,
                },
                fill: {
                    type: "gradient",
                    colors: ['#FFA64D', '#FFC34F'],
                    gradient: {
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 100],
                    },
                },
                plotOptions: {
                    area: {
                        fillTo: "end",
                    }
                },
                tooltip: {
                    enabled: true,
                    fillSeriesColor: true,
                    x: {
                        show: false,
                    },
                    y: {
                        formatter: (val, { seriesIndex, dataPointIndex, w }) => {
                            let time = w.config.series[seriesIndex].data[dataPointIndex].x.split(" ");
                            if (this.week) {
                                const [year, month, day] = time[0].split("-");
                                time = day + "." + month + " в " + time[1].slice(0, 5);
                            } else {
                                time = "в " + time[1].slice(0, 5);
                            }
                            return val ? val.toFixed(1) + "°C " + time : "";
                        },
                        title: {
                            show: false,
                        },
                    },
                    marker: {
                        show: false,
                    },
                },
                xaxis: {
                    type: "category",
                    labels: {
                        formatter: (val) => {
                            return this.getLabel(val);
                        },
                        style: {
                            colors: '#F8F8F8',
                        },
                    },
                    tickAmount: 9,
                    tickPlacement: "on",
                    tooltip: {
                        enabled: false
                    },
                },
                yaxis: {
                    labels: {
                        formatter: (val) => {
                            return val ? val.toFixed(1) + "°C" : "";
                        },
                        style: {
                            colors: '#F8F8F8',
                        },
                    },
                },
            },
            chartHumiditiesOptions: {
                chart: {
                    events: {
                        click: function(event, chartContext, config) {
                            let tooltip = chartContext.el.querySelector('.apexcharts-tooltip');
                            let pointsArray = config.globals.pointsArray;
                            let seriesIndex = config.seriesIndex;
                            let dataPointIndex = config.dataPointIndex === -1 ? 0 : config.dataPointIndex;

                            if (seriesIndex !== -1) {
                                let position = pointsArray[seriesIndex][dataPointIndex];

                                tooltip.style.top = position[1] + 'px';
                                tooltip.style.left = position[0] + 'px';
                            }
                        },
                        mouseMove: function(event, chartContext, config) {
                            let tooltip = chartContext.el.querySelector('.apexcharts-tooltip');
                            let pointsArray = config.globals.pointsArray;
                            let seriesIndex = config.seriesIndex;
                            let dataPointIndex = config.dataPointIndex === -1 ? 0 : config.dataPointIndex;

                            if (seriesIndex !== -1) {
                                let position = pointsArray[seriesIndex][dataPointIndex];

                                tooltip.style.top = position[1] + 'px';
                                tooltip.style.left = position[0] + 'px';
                            }
                        },
                    },
                    height: 350,
                    toolbar: {
                        show: false,
                    },
                    type: "area",
                    zoom: {
                        enabled: false,
                    },
                },
                colors: ["#FFA64D"],
                dataLabels: {
                    enabled: false,
                },
                fill: {
                    type: "gradient",
                    colors: ['#FFA64D', '#FFC34F'],
                    gradient: {
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 100],
                    },
                },
                plotOptions: {
                    area: {
                        fillTo: "end",
                    }
                },
                tooltip: {
                    enabled: true,
                    fillSeriesColor: true,
                    x: {
                        show: false,
                    },
                    y: {
                        formatter: (val, { seriesIndex, dataPointIndex, w }) => {
                            let time = w.config.series[seriesIndex].data[dataPointIndex].x.split(" ");
                            if (this.week) {
                                const [year, month, day] = time[0].split("-");
                                time = day + "." + month + " в " + time[1].slice(0, 5);
                            } else {
                                time = "в " + time[1].slice(0, 5);
                            }
                            return val ? val.toFixed(1) + "% " + time : "";
                        },
                        title: {
                            show: false,
                        },
                    },
                    marker: {
                        show: false,
                    },
                },
                xaxis: {
                    type: "category",
                    labels: {
                        formatter: (val) => {
                            return this.getLabel(val);
                        },
                        style: {
                            colors: '#F8F8F8',
                        },
                    },
                    tickAmount: 9,
                    tickPlacement: "on",
                    tooltip: {
                        enabled: false
                    }
                },
                yaxis: {
                    labels: {
                        formatter: (val) => {
                            return val ? val.toFixed(1) + "%" : "";
                        },
                        style: {
                            colors: '#F8F8F8',
                        },
                    },
                },
            },
        };
    },
    filters: {
        formatDate(val) {
            if (!val) {
                return null;
            }
            let [year, month, day] = val.split("-");
            return day + "." + month + "." + year;
        },
    },
    created() {
        eventBus.$on("reconnect", this.loadPage);
    },
    beforeDestroy() {
        eventBus.$off("reconnect", this.loadPage);
    },
    mounted() {
        this.loadPage();
    },
    computed: {
        title() {
            if (this.device && this.device.device_type == 7) {
                return "Температура";
            }
            if (this.device && this.device.device_type == 18) {
                return "Влажность";
            }
            return "Температура и влажность";
        },
        temperatures() {
            if (this.actions) {
                let data = this.actions;
                let temp = [];
                if (!this.week) {
                    data = JSON.parse(JSON.stringify(this.actions)).filter((el) => {
                        return el.date.split(" ")[0] == this.daysUniq[this.day]
                    });
                    data.forEach((el) => {
                        let obj = {y: el.state.temperature};
                        obj.x = el.date;
                        temp.push(obj);
                    });
                    if (this.day == 0) {
                        let i = temp[0] ? this.getLabel(temp[0].x) : -1;
                        for (i = parseInt(i) + 1; i < 24; i++) {
                            let hour = String(i).padStart(2, "0");
                            let exist = temp.find((el) => (el.x).split(" ")[1].slice(0, 2) === hour );
                            if (exist === undefined) {
                                temp.unshift({
                                    y: null,
                                    x: ` ${hour}:00`
                                });
                            }
                        }
                    }
                }
                else {
                    data.forEach((el) => {
                        let obj = {y: el.state.temperature};
                        obj.x = el.date;
                        temp.push(obj);
                    });
                }
                temp.reverse();
                return [ { name: "Температура", data: temp } ];
            }
            return [ { name: "Температура", data: [] } ];
        },
        humidities() {
            if (this.actions) {
                let data = this.actions;
                let temp = [];
                if (!this.week) {
                    data = JSON.parse(JSON.stringify(this.actions)).filter((el) => {
                        return el.date.split(" ")[0] == this.daysUniq[this.day]
                    });
                    data.forEach((el) => {
                        let obj = {y: el.state.humidity};
                        obj.x = el.date;
                        temp.push(obj);
                    });
                    if (this.day == 0) {
                        let i = temp[0] ? this.getLabel(temp[0].x) : -1;
                        for (i = parseInt(i) + 1; i < 24; i++) {
                            let hour = String(i).padStart(2, "0");
                            let exist = temp.find((el) => (el.x).split(" ")[1].slice(0, 2) === hour );
                            if (exist === undefined) {
                                temp.unshift({
                                    y: null,
                                    x: ` ${hour}:00`
                                });
                            }
                        }
                    }
                }
                else {
                    data.forEach((el) => {
                        let obj = {y: el.state.humidity};
                        obj.x = el.date;
                        temp.push(obj);
                    });
                }
                temp.reverse();
                return [ { name: "Влажность", data: temp } ];
            }
            return [ { name: "Влажность", data: [] } ];
        },
    },
    methods: {
        loadPage() {
            this.deviceUID = this.$route.query.device;
            this.deviceType = this.$route.query.type;
            if (this.deviceUID) {
                this.getData();
            }
        },
        getData() {
            this.openModalWaiting = true;
            let url = "";
            if (this.deviceType == "temp") {
                url = "/devices/home/temperature-history/";
            }
            if (this.deviceType == "hum") {
                url = "/devices/home/humidity-history/";
            }
            this.$http.get(url + this.deviceUID + '/')
                .then((res) => {
                    this.actions = res.data.actions;
                    this.device = res.data.device;
                    this.actions.forEach((el) => {
                        let date = el.date.split(" ")[0];
                        if (!this.daysUniq.includes(date)) {
                            this.daysUniq.push(date);
                        }
                    });
                    this.day = 0;
                })
                .finally(() => {
                    this.openModalWaiting = false;
                });
        },
        reduceDay() {
            if (this.day > 0) {
                this.day--;
            }
        },
        increaseDay() {
            if (this.day < this.daysUniq.length - 1) {
                this.day++;
            }
        },
        getLabel(val) {
            if (val) {
                if (!this.week) {
                    return String(parseInt((val).split(" ")[1].slice(0, 5).split(":")[0])).padStart(2, "0");
                }
                let dateLabel = val.split(" ")[0].split("-");
                return dateLabel[2] + "." + dateLabel[1];
            }
            return "";
        },
        back() {
            this.$router.push({ name: "homepage" });
        },
    },
}
</script>

<style lang="scss">
.main-container.container-fixed .remote-control {
    height: calc(100% - 54px);
    justify-content: flex-start;
}

.chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-height: 44px;
}

.location-header-row {
    top: -4px;
    position: relative;
    max-height: 24px;
}

.date-arrow {
    float: left;
    width: 28px;
    height: 28px;
    line-height: 32px;
    text-align: center;
    display: inline-flex;
    justify-content: center;
    align-items: center;

    &.left {
        transform: rotate(90deg);
    }

    &.right {
        transform: rotate(-90deg);
    }

    svg {
        stroke: #F8F8F8;
    }

    &__disabled {
        opacity: 0.3;
    }
}

.wrapper {
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
    max-height: 700px;
    display: block;
}

.line-buttons {
    min-height: 50px;
    max-height: 50px;
    height: 50px;
}
</style>